import PropTypes from "prop-types";
import "../assets/css/components.css";
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";

export const DateTimePicker = ({
  name = "",
  value = "",
  onChange = () => {},
  isValidDate,
  placeholder = "",
  isMandatory = true,
}) => {
  const DATE_FORMAT = "MM/DD/YYYY";
  const TIME_FORMAT = "HH:mm";
  const inputProps = {
    name,
    value,
    onChange,
    isValidDate,
  };

  return (
    <div className="wrapper">
      <label className="form-label">
        {placeholder}
        {isMandatory && <span className="mandatory-field">*</span>}
      </label>
      <Datetime
        {...inputProps}
        dateFormat={DATE_FORMAT}
        timeFormat={TIME_FORMAT}
        className="field"
      />
    </div>
  );
};

DateTimePicker.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  isValidDate: PropTypes.func,
  isMandatory: PropTypes.bool,
};
